import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { UserDeletedService } from '../../../api/userdeleted/userdeleted.service';
import { CountryGroupService } from '../../../api/countrygroup/countrygroup.service';
import { ComboCountryGroup } from '../../../api/countrygroup/combocountrygroup';
import { ApplicationService } from '../../../api/application/application.service';
import { ComboApplication } from '../../../api/application/comboapplication';
import { CountryModel } from '../../../api/country/country';
declare var $: any;
declare var jQuery: any;
@Component({
  selector: 'userdeleted-page',
  templateUrl: './userdeleted.html'
})
export class UserDeletedComponent implements OnInit {
  countryGroupList: ComboCountryGroup[];
  countryList : CountryModel[];
  selectCountryCode : string;
  selectCountryGroupID: string;
  selectUserStatus: string;
  selectPageLimit: string = "10";
  applicationList: ComboApplication[];
  selectApplication: string;
  directSearchText: string;
  totaluser: string = "0";
  userList = [];
  message: string;
  pageIndex: number = 0;
  visiblePaginationBtn = false;
  totalPages: number = 0;
  numbers: any; // [0,1,2,3,4]
  isDirectSearch: boolean;

  roleType: string;

  userpurchasedataList : any = [];
  userdevicedetaildataList : any = [];

  progressPer :string = "0%";

  isPreviousBtnEnable: boolean = true;
  isNextBtnEnable: boolean = true;

  thisuserData = {
    isupgradetopro : "",
    ispremiumuser : "",
    isprouser : "",
    ispurchase : "",
    subscription_expiredate : "",
    subscription_bundleId : ""
};

  constructor(
    private userDeletedService: UserDeletedService,
    private countrygroupService: CountryGroupService,
    private applicationService: ApplicationService,
    private router: Router
  ) {
  }
  ngOnInit() {
    if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN')) {
      this.progressPer = "0%";
      this.selectPageLimit = "10";
      this.selectUserStatus = "ALL";
      this.selectCountryGroupID = "ALL";
      this.selectCountryCode = "ALL";
      this.selectApplication = "ALL";
      this.roleType = localStorage.getItem("type");
      this.totaluser = "0";
      this.getInitData();
    }
    else {
      this.router.navigate(['/']);
    }
  }
  getUsers() {
    this.progressPer = "90%";
    this.userDeletedService.allUser(this.pageIndex * parseInt(this.selectPageLimit), parseInt(this.selectPageLimit), this.selectCountryGroupID, this.selectUserStatus, this.selectApplication,this.selectCountryCode).then(data => {
      this.progressPer = "100%";
      this.userList = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        var subList = [];
        if(element.subscriptions != null && element.subscriptions != undefined && element.subscriptions != "")
        {
          var _subJSON = JSON.parse(element.subscriptions);
          if( _subJSON.subscriptions != undefined)
          {
            for (var key in _subJSON.subscriptions) 
            {
              if (_subJSON.subscriptions.hasOwnProperty(key)) 
              {
                  const element1 = _subJSON.subscriptions[key];
                  if(element1.value.ispremiumuser == true || element1.value.ispremiumuser == 1)
                  {
                    const result = this.applicationList.filter((word) => word.sku == element1.key);
                    if(result.length > 0)
                    {
                      subList.push(result[0].appname);
                    }
                  }
              }
            }
          }
        }
        var _registerdate = this.formatDate(element.registerdate);
        var _lastactivedate = this.formatDate(element.lastactivedate);

        var userJson = {
          id: element.id,
          name: element.firstname + " " + element.lastname,
          logintype: element.logintype,
          devicetype : element.devicetype,
          devicesubtype : element.devicesubtype,
          countryname: element.countryname,
          lastactivedate : _lastactivedate,
          registerdate : _registerdate,
          subscriptionapplist: subList,

          subscriptions: element.subscriptions,
          extradata: element.extradata,
          token : element.token
        }
        this.userList.push(userJson);
      }
      this.progressTimeOut();
    });
  }

  progressTimeOut()
  {
    setTimeout(()=>
    { 
      this.progressPer = "0%"; 
    },200);
  }

  getInitData() {
    this.isDirectSearch = false;
    this.progressPer = "10%";
    this.applicationService
      .ComboApplication()
      .then(data => {
        this.progressPer = "25%";
        this.applicationList = data;
        this.selectApplication = "ALL";
      }).then(dttt => {
        this.countrygroupService
        .ComboCountryGroup()
        .then(data => {
          this.countryGroupList = data;
          this.countrygroupService
          .allCountryList()
          .then(data => {
              this.countryList = data;
              // this.selectCountryCode = $("#SELECTCOUNTRYCODE").val();
              // this.selectCountryGroupID = $("#SELECTCOUNTRYGROUP").val();
              // this.selectPageLimit = $("#SELECTPAGES").val();
              // this.selectUserStatus = $("#SELECTUSERSTATUS").val();
              this.getpaginationData();
          });
        });
      })
  }
  pageNext() {
    this.isDirectSearch = false;
    if (this.totalPages - 1 > this.pageIndex) {
      this.pageIndex = this.pageIndex + 1;
      this.getUsers();
      this.managepagination();
    }
  }
  pagePrevious() {
    this.isDirectSearch = false;
    if (this.pageIndex == 0) {
      return;
    }
    this.pageIndex = this.pageIndex - 1;
    this.getUsers();
    this.managepagination();
  }
  pageNavigateTo(num: number) {
    this.isDirectSearch = false;
    this.pageIndex = num;
    this.getUsers();
    this.managepagination();
  }
  managepagination() {
    this.totalPages = Math.ceil(parseInt(this.totaluser) / parseInt(this.selectPageLimit)); //parseInt($("#SELECTPAGES").val()));
    if (this.totalPages < 5) {
      this.visiblePaginationBtn = false;
      this.numbers = Array(this.totalPages).fill(0).map((x, i) => i);
    }
    else {
      this.visiblePaginationBtn = true;
      if (this.pageIndex == 2 || this.pageIndex == 1 || this.pageIndex == 0)//Selected Page Is 3,2,1
      {
        this.numbers = Array(5).fill(0).map((x, i) => i);
      }
      else if (this.pageIndex == this.totalPages - 3 || this.pageIndex == this.totalPages - 2 || this.pageIndex == this.totalPages - 1)//Selected Page Is 10,9,8
      {
        if (this.pageIndex == this.totalPages - 3) {
          var cnt = this.pageIndex - 2;
          for (let i = 0; i < 5; i++) {
            this.numbers[i] = cnt;
            cnt++;
          }
        }
        else if (this.pageIndex == this.totalPages - 2) {
          var cnt = this.pageIndex - 3;
          for (let i = 0; i < 5; i++) {
            this.numbers[i] = cnt;
            cnt++;
          }
        }
        else if (this.pageIndex == this.totalPages - 1) {
          var cnt = this.pageIndex - 4;
          for (let i = 0; i < 5; i++) {
            this.numbers[i] = cnt;
            cnt++;
          }
        }
      }
      else {
        var cnt = this.pageIndex - 2;
        for (let i = 0; i < 5; i++) {
          this.numbers[i] = cnt;
          cnt++;
        }
      }
    }
    if(this.pageIndex == 0)
    {
      this.isPreviousBtnEnable = false;
      this.isNextBtnEnable = true;
    }
    else if(this.pageIndex == this.totalPages-1)
    {
      this.isPreviousBtnEnable = true;
      this.isNextBtnEnable = false;
    }
    else
    {
      this.isPreviousBtnEnable = true;
      this.isNextBtnEnable = true;
    }
  }
  onApplicationChange(appValue) {
    this.pageIndex = 0;
    this.isDirectSearch = false;
    this.selectApplication = appValue;
    this.getpaginationData();
  }
  onCountryGroupChange(countryGroupValue) {
    this.pageIndex = 0;
    this.isDirectSearch = false;
    this.selectCountryGroupID = countryGroupValue;
    this.getpaginationData();
  }
  onCountryChange(countryCodeValue) {
    this.pageIndex = 0;
    this.isDirectSearch = false;
    this.selectCountryCode = countryCodeValue;
    this.getpaginationData();
  }
  onUserStatusChange(userstatus) {
    this.pageIndex = 0;
    this.isDirectSearch = false;
    this.selectUserStatus = userstatus;
    this.getpaginationData();
  }
  onPaginationChange(pagelimit) {
    this.isDirectSearch = false;
    this.pageIndex = 0;
    this.selectPageLimit = pagelimit;
    this.getpaginationData();
  }
  getpaginationData() {
    this.userDeletedService.paginationList(this.selectCountryGroupID, this.selectUserStatus, this.selectApplication,this.selectCountryCode).then(dd => {
      this.progressPer = "35%";
      this.totaluser = dd.totaluser;
      this.managepagination();
      this.getUsers();
    })
  }
  dateSeqChange(date)
  {
    //YYYY/MM/DD -> DD/MM/YYY
    if(date != "")
    {
      var arry = date.split('/');
      return arry[2] + "/" + arry[1] + "/" + arry[0];
    }
    else
    {
      return date;
    }
  }
  formatDate(dateVal) {
    if(dateVal == "")
    {
      return "";
    }
    else
    {
      var newDate = new Date(dateVal);

      var sMonth = this.padValue(newDate.getMonth() + 1);
      var sDay = this.padValue(newDate.getDate());
      var sYear = newDate.getFullYear();
      var sAMPM = this.formatAMPM(newDate);
      return sDay + "/" +sMonth + "/" + sYear + " " + sAMPM;
    }
  }
  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + '' + ampm;
    return strTime;
  }
  padValue(value) {
    return (value < 10) ? "0" + value : value;
}
  directSerach() {
    // if (this.directSearchText == undefined || this.directSearchText == "") {
    //   this.pageIndex = 0;
    //   this.isDirectSearch = false;
    //   this.getpaginationData();
    //   return;
    // }
    // this.isDirectSearch = true;
    // this.userDeletedService.directSearch(this.directSearchText).then(data => {
    //   this.userList = [];
    //   this.totaluser = "0";
    //   if (data != undefined && data != null) {
    //     this.totaluser = data.length.toString();
    //     for (let index = 0; index < data.length; index++) {
    //       const element = data[index];
    //       var subList = [];
    //       if (element.appsublist != undefined && element.appsublist != null) {
    //         var ssppp = element.appsublist.split(',');
    //         for (let index = 0; index < ssppp.length; index++) {
    //           const element = ssppp[index];
    //           subList.push(element);
    //         }
    //       }
    //       var userJson = {
    //         id: element.id,
    //         name: element.firstname + " " + element.lastname,
    //         email: element.email,
    //         logintype: element.logintype,
    //         devicetype : element.devicetype,
    //         devicesubtype : element.devicesubtype,
    //         countryname: element.countryname,
    //         lastactivedate : element.lastactivedate,
    //         registerdate : element.registerdate,
    //         totalbottlesaved : element.totalbottlesaved,
    //         subscriptionapplist: subList
    //       }
    //       this.userList.push(userJson);
    //     }
    //   }
    // });
  }
  showPurchaseData(thisuser)
  {   
      this.userpurchasedataList = [];
      if(thisuser.subscriptions != null && thisuser.subscriptions != undefined && thisuser.subscriptions != "")
      {
        var _subJSON = JSON.parse(thisuser.subscriptions);
        if( _subJSON.subscriptions != undefined)
        {
          for (var key in _subJSON.subscriptions) 
          {
            if (_subJSON.subscriptions.hasOwnProperty(key)) 
            {
                const element1 = _subJSON.subscriptions[key];
                if(element1.value.ispremiumuser == true || element1.value.ispremiumuser == 1)
                {
                  const result = this.applicationList.filter((word) => word.sku == element1.key);
                  if(result.length > 0)
                  {
                    var jData = {
                      appname : result[0].appname,
                      upgradetopro : element1.value.isupgradetopro,
                      proapp : element1.value.isprouser,
                      anypurchase : element1.value.ispurchase,
                      expiredate : element1.value.subscription_expiredate,
                      productid : element1.value.subscription_bundleId
                    }
                    this.userpurchasedataList.push(jData);
                  }
                }
            }
          }
        }
      }
      $(function () {
          $('#viewPurchaseDataModal').modal('toggle');
      });
  }
  showDeviceDetailData(thisuser)
  {   
      this.userdevicedetaildataList = [];
      if(thisuser.extradata != null && thisuser.extradata != undefined && thisuser.extradata != "")
      {
        var _subJSON = JSON.parse(thisuser.extradata);
        if( _subJSON.extradata != undefined)
        {
          for (var key in _subJSON.extradata) 
          {
            if (_subJSON.extradata.hasOwnProperty(key)) 
            {
                const element1 = _subJSON.extradata[key];
                const result = this.applicationList.filter((word) => word.sku == element1.key);
                  if(result.length > 0)
                  {
                    var jData = {
                      appname : result[0].appname,
                      appversion : element1.value.appversion,
                      installdate : element1.value.application_installeddate,
                      iswatchapp : element1.value.iswatchapp
                    }
                    this.userdevicedetaildataList.push(jData);
                  }
            }
          }
        }
      }
      $(function () {
          $('#viewDeviceDetailDataModal').modal('toggle');
      });
  }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/userdeleted/userdeleted.page.ts